export default __webpack_public_path__ + "static/media/features-middle.d64e7a9f.jfif";